import './style.css';
import { Game } from './game/Game';

const app = document.getElementById('app');
if (!app) throw new Error('Missing #app container');

new Game(app);
